import React from "react";

const CustomToggleButton = ({
  onActive,
  onClickHandle,
  size,
  disabled,
  cssClass
}) => {
  // size option ==> m, s
  // size option m is default size
  return (
    <div
      className={`cm-toggle-switch-wrap d-flex align-items-center ${cssClass}`}
      onClick={() => !disabled && onClickHandle()}
    >
      <div
        className={`cm-toggle-switch position-relative ${
          onActive ? "cm-toggle-switch-active" : ""
        } ${disabled ? "" : "cm-pointer"}`}
      >
        <div
          className={`${!onActive ? "bg-blue-gray-100" : "bg-action-1"} ${
            size === "s"
              ? "cm-toggle-switch-field-s "
              : "cm-toggle-switch-field "
          } border border-blue-gray-300 cm-btn-radius`}
        />
        <div
          className={`${
            size === "s"
              ? "cm-toggle-switch-trigger-s "
              : "cm-toggle-switch-trigger "
          } position-absolute bg-white border ${
            !onActive ? "border-blue-gray-300" : "border-action-1"
          } cm-btn-radius`}
        />
      </div>
    </div>
  );
};

export default CustomToggleButton;
